var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.sendMessage}},[_vm._v("发送消息")]),_c('ul',_vm._l((_vm.messageList),function(value,index){return _c('li',{key:index},[_vm._v(_vm._s(value))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }